module.exports = __webpack_public_path__ + "img/Corporate_Social_Responsibility_in_Action.212dbf1a.jpg";